export const generationJobStates = [
    "queued",
    "dispatched",
    "cancel_requested",
    "succeeded",
    "failed",
    "cancelled",
    "outcome_unknown",
    "superseded",
];
export const generationErrorCodes = [
    "PROVIDER_TIMEOUT",
    "PROVIDER_REJECTED",
    "MODERATION_BLOCKED",
    "BUDGET_EXHAUSTED",
    "INTERNAL",
];
// 🚨 lyrics 모드 가사 상한. MiniMax 동기 API 예산이 120초인데 2026-08-19 수업에서
//    1,410자 가사가 8회 전부 타임아웃했다(그날 성공 건은 전부 236자 이하). 서버(디스패치
//    422)와 클라이언트(입력 상한·카운터)가 같은 수를 봐야 하므로 여기에 둔다.
// 🔬 2026-08-20 실측(실호출 4회)으로 600 → 400 으로 내렸다: 239자=55.9초·399자=74.6초 성공,
//    599자·799자는 120초 예산 초과 타임아웃 — 600자는 상한이 아니라 사고 재현 구간이었다.
//    399자 실측 곡 분량 74초 ≥ 60초 컷이라 수업 분량에는 부족하지 않다(jery 결정).
export const LYRICS_MAX_CHARS = 400;
/**
 * 노래 길이 버튼(2026-10-18 jery) — 학생이 «1분 · 2분 · 3분 · AI 자유» 중에서 고른다.
 *
 * 🔑 상한(초)은 길이의 «보장» 이다 — Lyria 에는 길이 파라미터가 없어 프롬프트로 부탁만 하고,
 *    넘치면 서버가 페이드아웃으로 자른다(`capSongDuration`). 2·3분은 실측(2026-10-18 · 122초·171~179초)에
 *    5초 여유를 둬, 자연스럽게 끝난 곡의 끝을 자르지 않게 했다. AI 자유도 3분을 넘기지 않는다.
 * 🔑 1분은 종전 그대로다(60초 컷 · 가사 400자).
 */
export const SONG_LENGTHS = ["1", "2", "3", "auto"];
export const DEFAULT_SONG_LENGTH = "1";
export const SONG_LENGTH_CAP_SECONDS = {
    "1": 60,
    "2": 125,
    "3": 185,
    auto: 185,
};
export function isSongLength(value) {
    return typeof value === "string" && SONG_LENGTHS.includes(value);
}
/**
 * 2분·3분·AI 자유의 가사 상한. 실측 3분 곡 = 460자(2026-10-18).
 * 🚨 예비 제공자 MiniMax 는 2026-08-20 실측에서 599자가 120초 예산을 넘겼다 — 지금 예산은 180초라
 *    대개 들어가지만, Lyria 가 실패해 MiniMax 로 넘어간 긴 가사는 시간 초과가 날 수 있다(jery 감수 결정).
 */
export const LYRICS_MAX_CHARS_LONG = 600;
export function lyricsMaxCharsFor(length) {
    return length === "1" ? LYRICS_MAX_CHARS : LYRICS_MAX_CHARS_LONG;
}
export const musicWorkSteps = ["mode", "lyrics", "humming", "style", "result", "done"];
export const mvWorkSteps = ['song', 'story', 'cuts', 'mv_done', 'edit', 'final'];
/**
 * 그림 수업 단계 = 학생 화면 단계 표시줄 네 칸과 1:1 이다
 * (그림 고르기 · 그림 완성 · 노래 붙이기 · 작품 카드).
 * 🔑 `pic_pick` → `pic_image` 는 서버가 「그림 만들기」를 받을 때 넘긴다 — 첫 칸에 머문 학생만
 *    «아직 아무것도 안 함» 으로 세려면 두 칸이 나뉘어 있어야 한다(교사 활동 피드).
 */
export const pictureWorkSteps = ["pic_pick", "pic_image", "pic_song", "pic_done"];
/**
 * 포스터 수업 단계(2026-10-01 · 021) = 학생 화면 단계 표시줄 네 칸과 1:1
 * (그림 만들기 · 편집하기 · 노래·AR · 인쇄 확정).
 * 🔑 `pst_done` 은 «인쇄 확정을 한 번이라도 했다» 다 — 확정 뒤 고치면 확정은 풀리지만(D14)
 *    단계는 되돌리지 않는다. 확정이 «지금도 유효한가» 는 포스터 응답의 `confirmed_valid` 가 말한다.
 */
export const posterWorkSteps = ["pst_draw", "pst_edit", "pst_song", "pst_done"];
export const workSteps = [...musicWorkSteps, ...mvWorkSteps, ...pictureWorkSteps, ...posterWorkSteps];
/**
 * 학생이 처음 들어왔을 때의 단계. 🚨 세 갈래를 모두 적는다 — 예전 모양
 * `kind === "mv" ? "song" : "mode"` 는 그림 수업 학생을 음악 만들기 첫 화면으로 보냈다.
 */
export function firstWorkStep(kind) {
    if (kind === "mv")
        return "song";
    if (kind === "image")
        return "pic_pick";
    if (kind === "poster")
        return "pst_draw";
    return "mode";
}
/** 그 수업이 쓸 수 있는 단계 목록 */
export function workStepsFor(kind) {
    if (kind === "mv")
        return mvWorkSteps;
    if (kind === "image")
        return pictureWorkSteps;
    if (kind === "poster")
        return posterWorkSteps;
    return musicWorkSteps;
}
/**
 * 컷 그림·곡 올리기를 쓰는 수업인가(영상·그림). 세션 생성값(`upload_allowed`·그림 한도·
 * 그림 예산)이 이 값으로 켜진다.
 */
export function usesCutImages(kind) {
    return kind === "mv" || kind === "image" || kind === "poster";
}
/** 더 갈 데가 없는 단계 — 여기 닿지 않은 작업이 「진행 중」이다. */
export const finishedWorkSteps = ["done", "final", "pic_done", "pst_done"];
export function isWorkFinished(step) {
    return finishedWorkSteps.includes(step);
}
/**
 * 그림 수업의 고르기 칸. **키만** 오간다 — 프롬프트 문장은 서버가 조립한다
 * (`server/src/lib/picture-prompt.ts`). 클라가 프롬프트 문자열을 보내게 하면 학생 화면이
 * 곧 AI 입력창이 된다.
 * 🔑 라벨·이모지는 화면용이다. 키를 바꾸면 이미 저장된 작품(`style_chips`)이 못 읽힌다.
 */
export const pictureOptions = {
    gender: [
        { key: "boy", label: "남자아이", emoji: "👦" },
        { key: "girl", label: "여자아이", emoji: "👧" },
    ],
    hair: [
        { key: "short", label: "짧은 머리", emoji: "💇" },
        { key: "long", label: "긴 머리", emoji: "👩" },
        { key: "tied", label: "묶은 머리", emoji: "🎀" },
        { key: "curly", label: "곱슬머리", emoji: "🌀" },
    ],
    glasses: [
        { key: "no", label: "안 써요", emoji: "🙂" },
        { key: "yes", label: "써요", emoji: "👓" },
    ],
    expression: [
        { key: "smile", label: "웃는", emoji: "😊" },
        { key: "excited", label: "신나는", emoji: "🤩" },
        { key: "calm", label: "편안한", emoji: "😌" },
        { key: "cool", label: "멋진", emoji: "😎" },
    ],
    color: [
        { key: "red", label: "빨강", hex: "#ef4444" },
        { key: "orange", label: "주황", hex: "#f59e0b" },
        { key: "yellow", label: "노랑", hex: "#facc15" },
        { key: "green", label: "초록", hex: "#22c55e" },
        { key: "blue", label: "파랑", hex: "#3b82f6" },
        { key: "purple", label: "보라", hex: "#a855f7" },
        { key: "pink", label: "분홍", hex: "#ec4899" },
        { key: "brown", label: "갈색", hex: "#8b5a2b" },
    ],
    background: [
        { key: "sea", label: "바다", emoji: "🌊" },
        { key: "forest", label: "숲", emoji: "🌳" },
        { key: "space", label: "우주", emoji: "🚀" },
        { key: "school", label: "학교", emoji: "🏫" },
        { key: "park", label: "놀이공원", emoji: "🎡" },
        { key: "rainbow", label: "무지개", emoji: "🌈" },
    ],
    style: [
        { key: "crayon", label: "크레파스", desc: "꾹꾹 눌러 칠한 거친 느낌이에요." },
        { key: "water", label: "수채화", desc: "물감이 번진 부드러운 느낌이에요." },
        { key: "cartoon", label: "만화", desc: "굵은 선과 선명한 색이에요." },
        { key: "book", label: "동화책", desc: "그림책 속 따뜻한 느낌이에요." },
        { key: "paper", label: "색종이", desc: "종이를 오려 붙인 느낌이에요." },
        { key: "doll", label: "3D 인형", desc: "말랑한 인형 같은 입체 느낌이에요." },
    ],
};
/** 「한 줄 더하기」 상한. 서버 zod 와 화면 카운터가 같은 수를 본다. */
export const PICTURE_LINE_MAX_CHARS = 100;
/**
 * 저장된 `style_chips` 를 그림 칸으로 읽는다. 모르는 키가 섞였으면 null — 옛 값·손상된 값을
 * «골라진 것» 으로 보이지 않게 한다. 서버(zod)가 쓰기 전에 이미 검사하므로 정상 경로에서는
 * 늘 통과한다.
 */
export function parsePictureChoices(raw) {
    if (!raw || typeof raw !== "object")
        return null;
    const value = raw;
    const groups = ["gender", "hair", "glasses", "expression", "color", "background", "style"];
    const known = (group, key) => typeof key === "string"
        && pictureOptions[group].some((option) => option.key === key);
    if (groups.some((group) => value[group] !== undefined && value[group] !== null && !known(group, value[group]))
        || (value.line !== undefined && value.line !== null && typeof value.line !== "string")) {
        return null;
    }
    const choices = {};
    for (const group of groups) {
        if (typeof value[group] === "string")
            choices[group] = value[group];
    }
    if (typeof value.line === "string" && value.line.trim())
        choices.line = value.line;
    return hasPictureInput(choices) ? choices : null;
}
/** 칸 하나라도 골랐거나 한 줄을 적었으면 그릴 수 있다. 화면 버튼과 서버 검사가 같은 함수를 본다. */
export function hasPictureInput(choices) {
    return Boolean(choices.gender || choices.hair || choices.glasses || choices.expression
        || choices.color || choices.background || choices.style || choices.line?.trim());
}
export const motions = ["zoom_in", "zoom_out", "pan", "ai_video"];
/**
 * 뮤직비디오 컷 그림 분위기(MV 3 · 컷 만들기).
 * 🔑 DB(`mvs_works.art_direction`)에는 `label` 문장이 그대로 들어가고, 그 문장이 그림 프롬프트에 실린다.
 *    그래서 label 을 바꾸면 이미 고른 작품의 버튼 표시가 풀린다 — 바꾸지 말 것.
 * 예시 그림 = `client/public/mv-styles/<key>.webp`(컷 그림과 같은 프롬프트·모델로 만든 16:9 · 2026-10-20).
 */
export const mvArtDirections = [
    { key: "storybook", label: "따뜻한 동화책", desc: "그림책을 펼친 것처럼 포근하고 따뜻한 그림이에요." },
    { key: "anime", label: "선명한 애니메이션", desc: "굵은 선과 또렷한 색으로 그린 만화 영화 같은 그림이에요." },
    { key: "watercolor", label: "몽글몽글 수채화", desc: "물감이 번져서 부드럽고 몽글몽글한 그림이에요." },
    { key: "papercut", label: "종이 오려 붙이기", desc: "색종이를 오려서 겹쳐 붙인 것 같은 그림이에요." },
    { key: "pixel", label: "레트로 픽셀 아트", desc: "옛날 게임처럼 작은 네모 점으로 그린 그림이에요." },
    { key: "popart", label: "신나는 팝아트", desc: "쨍한 색과 굵은 무늬로 그린 신나는 그림이에요." },
];
/**
 * 「선택 안 함」 칸(2026-10-20 jery · 나안). 이 값이면 그림 프롬프트에 분위기 문장을 **아예 넣지 않고**
 * 학생이 쓴 장면만으로 그린다.
 * 🚨 빈 문자열과 다르다 — 빈 값은 «아직 안 고름» 이고, 서버는 빈 값이면 기본 분위기(«따뜻하고 밝은 일러스트»)를 넣는다.
 */
export const ART_DIRECTION_NONE = "선택 안 함";
/**
 * 뮤직비디오 컷 배치 — **컷 1→2→3→4 순서로 한 바퀴 돌고, 노래가 남으면 같은 순서를 되풀이한다**(2026-10-20 jery).
 *
 * 🔁 종전(PR #251)에는 노래 길이 ÷ 컷 수를 컷마다 주고 짧은 AI 클립을 그 안에서 되풀이했다.
 *    3분 곡에 컷 4개면 컷 1 클립이 44초 동안 반복된 뒤에야 컷 2 로 넘어갔다.
 * 한 바퀴 안에서 각 컷이 맡는 길이:
 *   - AI 영상 컷 = 그 클립의 원래 길이(`clipSeconds`)
 *   - 정지 그림 컷(카메라 움직임) = `CUT_LOOP_IMAGE_SECONDS`(5초 = 그림·포스터 수업의 AI 클립 길이)
 * 노래 끝에서 마지막 조각은 남은 시간만큼 잘린다. 단 `CUT_LOOP_MIN_SEGMENT_SECONDS` 보다 짧게
 * 남으면 새 조각을 만들지 않고 바로 앞 조각을 그만큼 늘린다(너무 짧은 조각은 전환 효과가 들어갈 자리가 없다).
 * 컷이 하나뿐이면 조각을 나누지 않고 한 조각이 노래 전체를 맡는다(같은 그림끼리 전환하지 않는다).
 *
 * 🩸 `overlapSeconds` = 크로스페이드처럼 **조각끼리 겹치는 시간**. 겹침마다 영상이 그만큼 짧아지므로,
 *    조각 하나가 시간축에서 실제로 전진하는 길이는 `seconds - overlap` 이다. 이걸 빼먹으면 3분 곡(조각 36개)
 *    영상이 18초 짧아져 노래 끝이 잘린다(2026-10-20 실측 167초). 그래서 전진 길이로 배치하고 겹침만큼 더해 돌려준다
 *    — AI 클립은 원래 길이 그대로 다 나오고, 앞뒤 0.5초가 이웃 조각과 섞인다.
 *
 * 서버 합성(compose-worker)과 편집실 미리보기(EditPage)가 **같은 함수**를 쓴다 — 화면과 결과가 어긋나지 않게.
 */
export const CUT_LOOP_IMAGE_SECONDS = 5;
export const CUT_LOOP_MIN_SEGMENT_SECONDS = 1.5;
/** AI 클립 한 조각의 하한(초) — 합성 정규화가 1초 미만 조각을 거부한다. */
export const CUT_LOOP_MIN_CLIP_SECONDS = 1;
export function planCutLoop(cuts, totalSeconds, overlapSeconds = 0) {
    if (cuts.length < 1 || !Number.isFinite(totalSeconds) || totalSeconds <= 0)
        return [];
    const overlap = Number.isFinite(overlapSeconds) && overlapSeconds > 0 ? overlapSeconds : 0;
    if (cuts.length === 1)
        return [{ cutIndex: 0, seconds: totalSeconds + overlap }];
    // 🩸 AI 클립은 1초짜리도 있다(CLIP_MIN_SECONDS=1). 종전엔 1.5초 미만을 «그림 컷» 으로 보고 5초를 줘서,
    //    짧은 노래에서는 그 컷 하나가 노래 전체를 덮었다(Codex 검수 2026-10-20). 길이가 있으면 그대로 쓰되,
    //    합성 조각의 하한(1초 · compose COMPOSE_CLIP_DURATION_INVALID)은 지킨다 — ffprobe 는 «1초» 클립을 0.96 처럼 잴 수 있다.
    const lap = cuts.map((cut) => (cut.clipSeconds !== null && Number.isFinite(cut.clipSeconds) && cut.clipSeconds > 0
        ? Math.max(cut.clipSeconds, CUT_LOOP_MIN_CLIP_SECONDS)
        : CUT_LOOP_IMAGE_SECONDS) - overlap);
    const segments = [];
    let used = 0;
    for (let index = 0; used < totalSeconds - 1e-6; index = (index + 1) % cuts.length) {
        const left = totalSeconds - used;
        const want = lap[index] ?? CUT_LOOP_IMAGE_SECONDS;
        const previous = segments.at(-1);
        if (left < CUT_LOOP_MIN_SEGMENT_SECONDS && previous) {
            previous.seconds += left;
            break;
        }
        const seconds = Math.min(want, left);
        segments.push({ cutIndex: index, seconds });
        used += seconds;
    }
    return overlap > 0 ? segments.map((segment) => ({ ...segment, seconds: segment.seconds + overlap })) : segments;
}
export const editTransitions = ["crossfade", "hardcut", "fadeblack"];
export const composeStates = [
    "idle",
    "queued",
    "dispatched",
    "cancel_requested",
    "succeeded",
    "failed",
    "cancelled",
    "outcome_unknown",
    "superseded",
];
export const editApiErrorCodes = [
    "STEP_GUARD",
    "LIMIT_EXCEEDED",
    "FEATURE_DISABLED",
    "JOB_ACTIVE",
    "CUTS_INCOMPLETE",
    "CLIP_MISSING",
    "IDEMPOTENCY_CONFLICT",
    "IDEMPOTENCY_KEY_REQUIRED",
];
// ─────────────────────────────────────────────────────────────────────────────
// 포스터 수업(poster · 2026-10-01) — 정본 설계 docs/PLAN-poster-build.md
/** 그림 칸 최대 3개 — 학생은 1칸으로 시작해 「그림 더 만들기」로 늘린다. 문서는 자산 id 가 아니라 칸 번호를 가리킨다(D14). */
export const POSTER_SLOTS = [1, 2, 3];
/** 화면에 보이는 칸 이름(2026-10-04 — 큰 그림/작은 그림 대신). */
export const POSTER_SLOT_NAME = { 1: "그림 1", 2: "그림 2", 3: "그림 3" };
export const POSTER_SHAPES = ["portrait", "landscape", "square"];
export const POSTER_SHAPE_LABEL = { portrait: "세로", landscape: "가로", square: "정사각" };
/** 가로 ÷ 세로 */
export const POSTER_SHAPE_ASPECT = { portrait: 3 / 4, landscape: 4 / 3, square: 1 };
/** 모양을 고르기 전 칸의 모양 — 2026-10-04 이전 그림도 이 규칙으로 그려졌다(1 = 세로 · 2·3 = 정사각). */
export function defaultPosterShape(slot) {
    return slot === 1 ? "portrait" : "square";
}
/** 「어떤 그림을 그릴까요?」 상한(입력 문서 1단계). 서버 zod 와 화면 카운터가 같은 수를 본다. */
export const POSTER_PROMPT_MAX_CHARS = 300;
/** 학생당 올린 사진 수(D13) — DB 함수 021 mvs_add_poster_photo 와 같은 수. */
export const POSTER_PHOTO_LIMIT = 5;
export const POSTER_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
/**
 * 다시 그리기 «모든 그림이 합쳐서» 횟수(D2) — 세션 image_regen_limit 로 저장된다(수업 만들 때 정해진다).
 * 🔑 10 = 2026-10-04 jery 결정(포스터만 · 다른 수업은 5 그대로). 모자라면 교사 선물.
 *    학생 1명 최대 = 첫 그림 3장 + 10 = 13장. 앱 하루 상한(MVS_DAILY_IMAGE_CAP)은 다른 수업과 함께 쓴다.
 */
export const POSTER_REGEN_LIMIT = 10;
/** A3 세로(mm). 편집 문서의 좌표 단위는 mm 다(D4). */
export const POSTER_PAGE = { width: 297, height: 420 };
